//Job
export const BASE_JOB_PORTAL = "/api/portal";

//Parse resume
export const BASE_PARSE_RESUME = "/api/resumes";

//Candidate
export const BASE_CANDIDATES = "/api/candidates";

//Document conversion
export const DOCUMENT_CONVERSION = "api/document-conversion";

// Ai service
export const BASE_LLM_INTERVIEW = "/api/llm-interview";

// Document
export const BASE_DOCUMENTS = "/api/documents";